/* Theme Name: Worthy - Free Powerful Theme by HtmlCoder
 * Author:HtmlCoder
 * Author URI:http://www.htmlcoder.me
 * Version:1.0.0
 * Created:November 2014
 * License: Creative Commons Attribution 3.0 License (https://creativecommons.org/licenses/by/3.0/)
 * File Description: Initializations of plugins
 */

(function ($) {
    $(document).ready(function () {
        $(".banner-image").backstretch('images/banner.jpg');

        // Animations
        //-----------------------------------------------
//        if (($("[data-animation-effect]").length > 0) && !Modernizr.touch) {
//            $("[data-animation-effect]").each(function () {
//                var $this = $(this),
//                    animationEffect = $this.attr("data-animation-effect");
//                if (Modernizr.mq('only all and (min-width: 768px)') && Modernizr.csstransitions) {
//                    $this.appear(function () {
//                        setTimeout(function () {
//                            $this.addClass('animated object-visible ' + animationEffect);
//                        }, 400);
//                    }, {accX: 0, accY: -130});
//                } else {
//                    $this.addClass('object-visible');
//                }
//            });
//        }
//        ;

        // Isotope filters
        //-----------------------------------------------
        if ($('.isotope-container').length > 0) {
            $(window).load(function () {
                $('.isotope-container').fadeIn();
                var $container = $('.isotope-container').isotope({
                    itemSelector: '.isotope-item',
                    layoutMode: 'masonry',
                    transitionDuration: '0.6s',
                    filter: "*"
                });
                // filter items on button click
                $('.filters').on('click', 'ul.nav li a', function () {
                    var filterValue = $(this).attr('data-filter');
                    $(".filters").find("li.active").removeClass("active");
                    $(this).parent().addClass("active");
                    $container.isotope({filter: filterValue});
                    return false;
                });
            });
        }
        ;


    }); // End document ready
})(this.jQuery);


/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
'use strict';
var app = angular.module("app", []);
app.version = 1;
app.config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
});
app.controller("sitePagesController", function ($scope, $http, $q, $sce, $timeout, $compile, $window, $location, $userService, $postService, $loadService, $alertService, $getService) {
    initBase($scope, $http, $timeout, $sce, $compile, $window, $location, $postService, $alertService);

    $scope.loginForm = {
        email: null,
        password: null
    };

    $scope.logging = false;
    $scope.loginSubmit = function () {
        var email = $scope.loginForm.email;
        var password = $scope.loginForm.password;
        if (typeof email === 'undefined' || email === null) {
            alert("Please enter correct email");
            return;
        }
        if (typeof password === 'undefined' || password === null) {
            alert('Please enter correct password. (Min characters 5)');
            return;
        }
        $scope.logging = true;
        var url = '/login';
        $http.post(url, $scope.loginForm).then(function (response) {
            $scope.logging = false;
            if (response.data.status) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                window.location = '/dashboard';
            } else {
                alert('Incorrect Credentials');
                $scope.logging = false;
            }
        });
    };


    $scope.contact = {name: null, email: null, message: null};
    $scope.contacting = false;
    $scope.submitContactForm = function () {
        var contact = $scope.contact;
        if (contact.name == null || contact.name.length == 0) {
            alert('Please provide name');
            return;
        }
        if (contact.email == null || contact.email.length == 0) {
            alert('Please provide email');
            return;
        }
        if (contact.message == null || contact.message.length == 0) {
            alert('No Message Provided');
            return;
        }

        $scope.contacting = true;
        var url = "/contactRequest"
        $http.post(url, $scope.contact).then(function (response) {
            $scope.contacting = false;
            alert('Thanks for reaching, we will revert asap.');
            $scope.contact = {name: null, email: null, message: null};
        });
    }
});